export type { BlockView, BlockViewResponse } from '@packet/management';
import type { BlockView } from '@packet/management';

// 通用分页请求参数
export interface PaginationParams {
  offset: number;
  limit: number;
  order?: 'asc' | 'desc';
}

// 通用分页响应数据
export interface PaginationResponse<T> {
  data: T[];
  total: number;
}

// 通用API响应格式
export interface ApiResponse<T = any> {
  code: number;
  message: string;
  data: T;
}

/**
 * Handle block_view from API response - log info for debugging
 */
export const handleBlockViewResponse = <T>(response: { block_view?: BlockView; data?: T }, endpoint: string): T | undefined => {
  if (response.block_view) {
    console.debug(`[BlockView] Response from ${endpoint}:`, response.block_view);
  }
  return response.data;
};
